/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: types.ts
 * Class: types.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationRequestState } from '../types';
import { BaseMoney } from '../price/types';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';

export interface CreatePaymentRequest {
  mode: string;
  method_id: number;
  return_url: string;
  price: BaseMoney;
  // ignoring this line since it contains data from adyen, which is not typed
  // https://github.com/Adyen/adyen-web/issues/396
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any;
  amount?: number;
}

/**
 * step three for a migrated customer paying with one of their Chargebee payment sources: the balance
 * is left alone, and step four's activation collects the whole order from this source
 */
export interface ChargebeeCheckoutRequest {
  payment_source_id: string;
  price: BaseMoney;
}

export interface CreatePaymentResponse {
  paymentId: string;
  resultCode: PaymentStates;
  redirectUrl: string;
  mode: string;
  action: PaymentAction;
}

export interface PaymentResponse {
  id: string;
  status: string;
  amount: number;
  currency: string;
  created: string;
  formattedPrice: string;
}

export interface VerifyPaymentRequest {
  mode: string;
  paymentId: string;
}

export interface VerifyPaymentResponse {
  redirectUrl: string;
  paymentId: string;
  status: PaymentStates;
}

export interface AdditionalPaymentDetailsRequest {
  mode: string;
  // ignoring this line since it contains data from adyen, which is not typed
  // https://github.com/Adyen/adyen-web/issues/396
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
  paymentId?: string;
}

export type AdditionalPaymentDetailsResponse = CreatePaymentResponse

export enum PaymentMode {
  CHECKOUT = 'checkout',
  RECURRING_SETUP = 'recurring',
  RECHARGE = 'recharge'
}

export enum PaymentStates {
  CANCEL = 'cancel',
  CHECKOUT = 'checkout',
  CREATED = 'created',
  FAILURE = 'failure',
  PENDING = 'pending',
  SUCCESS = 'success'
}

export enum PaymentEnumMutations {
  CREATE_PAYMENT_ERROR = 'createPaymentError'
}

export interface PaymentState {
  createPayment: MutationRequestState<CreatePaymentResponse, string>;
  disableMethod: MutationRequestState<void, string>;
  verifyPayment: MutationRequestState<void, string>;
  getPayment: MutationRequestState<void, string>;
  additionalPaymentDetails: MutationRequestState<AdditionalPaymentDetailsResponse, string>;
}

export interface LagoCreatePaymentRequest {
  /**
   * normalized to the smallest currency unit, e.g. cents for EUR, yen for JPY
   */
  amount: number;
  description: string;
}

export interface LagoCreatePaymentResponse {
  payment: {
    id: string,
    status: PaymentStates,
  }
}

export type LagoPaymentStatusRequest = string;

export interface LagoPaymentStatusResponse {
  payment: {
    id: string,
    status: PaymentStates,
  }
}
